import { IUIUrval, RutinUrvalType } from '../../../../Types/UrvalTypes';
import EDButton from '../../../../BaseComponents/Buttons/Button/EDButton';
import EDOpen from '../../../../BaseComponents/Open/EDOpen';
import EDIcon from '../../../../BaseComponents/Icon/EDIcon';
import AdvancedUrvalDialog from '../AdvancedUrvalDialog/AdvancedUrvalDialog';
import EDTooltip from '../../../../BaseComponents/Tooltip/EDTooltip';
import EDKeybind from '../../../../BaseComponents/Keybinds/EDKeybind';
import { RutinUrvalListQueryVariables } from '../SavedUrval/Queries/RutinUrvalListQuery/_QueryTypes/RutinUrvalListQuery';

interface IProps {
  buttonTooltip?: string;
  codeSystemID?: string;
  collectionName: string;
  kodbehorighetsUrval?: IUIUrval;
  kodplanUrval: boolean;
  routineID?: number;
  rutinUrvalList?: RutinUrvalType[] | null;
  rutinUrvalVariables?: RutinUrvalListQueryVariables;
  setUrval: (newUrval: IUIUrval) => void;
  showIcon?: boolean;
  urval: IUIUrval | null;
  disableVirtualTreeSelect?: boolean;
}

/**
 * En standarddiseras knapp för att öppna upp AvancedUrvalDialog komponenten.
 */
const AdvancedUrvalButton = (props: IProps) => (
  <EDOpen>
    {(open, onOpen, onClose) => (
      <>
        <EDTooltip
          title={!props.kodbehorighetsUrval ? props.buttonTooltip : undefined}
        >
          <span>
            <EDKeybind
              keymap="v"
              alt
              global
              onKeyDown={!open ? onOpen : onClose}
            >
              <EDButton
                icon={
                  props.showIcon ? (
                    <EDIcon
                      marginRight={1}
                      iconType="filter_list"
                      color="inherit"
                    />
                  ) : undefined
                }
                label={'Avancerat urval'}
                labelNotUpperCase
                lowEmphasis
                flat
                primary
                padding={1}
                onClick={onOpen}
                disabled={!props.kodbehorighetsUrval}
              />
            </EDKeybind>
          </span>
        </EDTooltip>
        {open && props.kodbehorighetsUrval && (
          <AdvancedUrvalDialog
            urval={props.urval}
            setUrval={props.setUrval}
            collectionName={props.collectionName}
            rutinUrvalList={props.rutinUrvalList}
            rutinUrvalVariables={props.rutinUrvalVariables}
            routineID={props.routineID}
            codeSystemID={props.codeSystemID}
            onClose={onClose}
            open={open}
            kodplanUrval={props.kodplanUrval}
            kodbehorigheturval={props.kodbehorighetsUrval}
            disableVirtualTreeSelect={props.disableVirtualTreeSelect}
          />
        )}
      </>
    )}
  </EDOpen>
);

export default AdvancedUrvalButton;
